module.exports = __webpack_public_path__ + "static/anvilwrought_raptor-717015532b65632f367c889f06485c71.jpeg";